import type { ModalProps } from "./types";
import React, { useEffect, useCallback } from "react";
import { createPortal } from "react-dom";

const ModalComponent: React.FC<ModalProps> = ({ show, children, heigth, width, onClose, title }) => {
	const handleEscapeKey = useCallback(
		(event: KeyboardEvent) => {
			if (event.key === "Escape" && show && onClose) {
				onClose();
			}
		},
		[show, onClose],
	);

	useEffect(() => {
		if (show) {
			document.addEventListener("keydown", handleEscapeKey);
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}

		return () => {
			document.removeEventListener("keydown", handleEscapeKey);
			document.body.style.overflow = "unset";
		};
	}, [show, handleEscapeKey]);

	if (!show) return null;

	const modalContent = (
		<div
			className={`
         fixed z-50 inset-0 flex justify-center items-center transition-colors
        ${show ? "visible bg-black/20" : "invisible"}
      `}
			role="dialog"
			aria-modal="true"
			aria-labelledby={title ? "modal-title" : undefined}
			style={{ top: 0, left: 0, right: 0, bottom: 0 }}>
			<div
				style={{
					width: `${width}%`,
					maxHeight: `${heigth}%`,
					height: "fit-content",
				}}
				onClick={e => e.stopPropagation()}
				className={`
          bg-modal-bg text-black shadow transition-all rounded-lg border overflow-y-auto 
          ${show ? "scale-100 opacity-100" : "scale-125 opacity-0"}
        `}
				role="document"
				tabIndex={-1}>
				{title && (
					<h2 id="modal-title" className="sr-only">
						{title}
					</h2>
				)}
				{children}
			</div>
		</div>
	);

	// Use portal to render modal at document body level, bypassing any stacking context issues
	return createPortal(modalContent, document.body);
};

export const UserModal = React.memo(ModalComponent);
